import request from '@/utils/request'
import axios from "axios";

// 通过后端凭证读取 OSS 文件，避免浏览器或 C-Lodop 直接访问 OSS
export function getOssPdf(fileUrl) {
    return request({
        url: '/api/oss/proxy',
        method: 'get',
        params: { url: fileUrl },
        responseType: 'arraybuffer'
    })
}

export function addProduct(data) {
    return request({
        url: '/produce/add',
        method: 'post',
        data
    })
}

export function getProductList(params) {
    return request({
        url: '/produce/all',
        method: 'get',
        params
    })
}
export function getAllProducts(params) {
    return request({
        url: '/produce/all-own',
        method: 'get',
        params
    })
}

export function updateProduct(data) {
    return request({
        url: '/produce/update',
        method: 'post',
        data
    })
}

// 查询产品编辑详情：response.data.product 为产品对象，能力标记(canEdit/canEditSku/canSave/canSaveAndApprove)与 product 同级
export function getProductEditDetail(productId) {
    return request({
        url: `/produce/detail/${productId}`,
        method: 'get'
    })
}

// 阿里云OSS单文件上传（产品图片/附件等），folder 为OSS目录名（从OMS迁移）
// 返回结构：{ code, data:{ url, name }, msg }
// 兼容逻辑：
// 1. 不传参时默认值为 attachments（兼容右侧原逻辑）
// 2. 传入假值（空串/null/0等）时回退为 products（兼容左侧原容错逻辑）
export function ossUploadFile(file, folder) {
    const formData = new FormData();
    formData.append('file', file);
    // 兼容两侧默认目录规则
    const targetFolder = folder === undefined
        ? 'attachments'
        : (folder || 'products');
    formData.append('folder', targetFolder);

    return request({
        url: '/api/oss/upload',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function batchUpdateProducts(data) {
    return request({
        url: '/produce/batchUpdate',
        method: 'post',
        data
    })
}

export function importProducts(data) {
    return request({
        url: '/produce/import',
        method: 'post',
        data,
    })
}

export function getInboundList(params) {
    return request({
        url: '/inbound/all',
        method: 'get',
        params
    })
}

export function getTransferOrderList(params) {
    return request({
        url: '/transferOrder/list',
        method: 'get',
        params
    })
}

export function getTransferOrderPalletDetail(transferId) {
  return request({
    url: '/transferOrder/palletDetail/' + transferId,
    method: 'get'
  });
}

export function getLatestReceivePutawayData(transferId) {
  return request({
    url: '/transferOrder/latestReceivePutawayData/' + transferId,
    method: 'get'
  });
}

export function executePutaway(data) {
    return request({
        url: '/wms/putaway/execute',
        method: 'post',
        data
    })
}

export function getOmsCustomerCodes() {
    return request({
        url: '/transferOrder/customerCodes',
        method: 'get'
    })
}

export function getInboundOrderDetail(id) {
    return request({
        url: `/inbound/${id}`,
        method: 'get'
    })
}

export function updateInbound(data) {
    return request({
        url: '/inbound/update',
        method: 'post',
        data
    })
}

export function checkOut(data) {
    return request({
        url: '/inbound/checkOut',
        method: 'post',
        data
    })
}

export function submitReceipt(data) {
    return request({
        url: '/inbound/submitReceipt',
        method: 'post',
        data
    })
}

export function createPutawayOrder(data) {
    return request({
        url: '/putaway/createPutawayOrder',
        method: 'post',
        data
    })
}

export function getPutawayOrderList(params) {
    return request({
        url: '/putaway/getPutawayOrder',
        method: 'get',
        params
    })
}

/**
 * 上架明细分页（一行 = 一个上架单下的一个 SKU）
 * 与 getPutawayOrderList 的区别：后者按上架单分页（total 是单数），本接口按明细分页，
 * total 等于列表行数。上架管理列表用它，避免「列表行数和总条数对不上」。
 */
export function getPutawayOrderItemPage(params) {
    return request({
        url: '/putaway/getPutawayOrderItemPage',
        method: 'get',
        params
    })
}

export function updatePutawayOrderItem(data) {
    return request({
        url: '/putaway/updatePutawayOrderitem',
        method: 'post',
        data
    })
}

/*
export function importProducts(data) {
    const instance = axios.create();
    return instance({
        url: process.env.VUE_APP_BASE_API + '/produce/import',
        method: 'post',
        data,
    });
}*/
export function getOrderWithItemsPage(params) {
    return request({
        url: '/orders/getOrderWithItemsPage',
        method: 'get',
        params
    })
}

// 导出订单 Excel（与 getOrderWithItemsPage 相同查询条件，后端生成 xlsx 流）
export function exportOrdersAll(params) {
    return request({
        url: '/orders/exportOrders',
        method: 'get',
        params,
        responseType: 'blob',
        timeout: 120000,
    }).then(response => {
        if (!response) {
            throw new Error('导出失败：服务器无响应');
        }
        if (!response.headers) {
            throw new Error('导出失败：响应头为空');
        }

        // 后端异常（如导出数据量过大）由 GlobalExceptionHandler 以 JSON + HTTP200 返回，
        // 此时 responseType=blob 会把 JSON 包成 Blob，需要识别出来并解析错误信息，避免下载到损坏文件
        const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
        if (contentType.indexOf('application/json') !== -1) {
            return response.data.text().then(text => {
                let msg = '导出失败';
                try {
                    const j = JSON.parse(text);
                    msg = j.msg || j.message || msg;
                } catch (e) {
                    if (text) msg = text;
                }
                throw new Error(msg);
            });
        }

        // 解析文件名（兜底：Content-Disposition 缺失时用时间戳）
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        let fileName = `订单导出_${new Date().getTime()}.xlsx`;
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]) + '.xlsx';
            }
        }

        if (!response.data) {
            throw new Error('导出失败：无导出数据');
        }

        // 生成 Blob 并触发下载
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    }).catch(error => {
        // 二进制流错误需异步读取 Blob 才能拿到后端提示文本
        return new Promise((_, reject) => {
            console.error('导出失败:', error);
            if (!error.response) {
                reject(new Error(error.message || '导出失败：服务器响应异常'));
                return;
            }
            const errorData = error.response.data;
            if (errorData instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    reject(new Error(reader.result || '导出数据量过大或服务器异常'));
                };
                reader.onerror = () => {
                    reject(new Error('导出失败：无法解析错误信息'));
                };
                reader.readAsText(errorData);
            } else {
                reject(new Error(error.message || '导出失败，请联系管理员'));
            }
        });
    });
}

// 创建订单
export function createOrderWithItems(data) {
    return request({
        url: '/orders/createOrderWithItems',
        method: 'post',
        data
    })
}

// 根据订单号查询订单详情（用于按单打包，不需要用户ID）
export function getOrderByOrderNo(orderNo) {
    return request({
        url: '/orders/getOrderByOrderNo',
        method: 'get',
        params: {
            orderNo: orderNo
        }
    })
}

export function createPickOrders(data) {
    return request({
        url: '/pickOrder/create',
        method: 'post',
        data
    })
}

export function updateOrder(data) {
    return request({
        url: '/orders/updateOrder',
        method: 'post',
        data
    })
}

// 根据订单号更新订单状态（用于打包完成后更新状态为已发货）
export function updateOrderState(orderNo, state) {
    return request({
        url: '/orders/updateOrderState',
        method: 'post',
        params: { orderNo, state }
    })
}

// 提交订单（更新状态为待审核，并计算费用）
export function submitOrder(orderNo) {
    return request({
        url: '/orders/submitOrder',
        method: 'post',
        params: { orderNo }
    })
}

// 提交并审核订单（更新状态为待发货，并计算费用）
export function submitAndApproveOrder(orderNo) {
    return request({
        url: '/orders/submitAndApproveOrder',
        method: 'post',
        params: { orderNo }
    })
}

// 获取运单号
export function createTrackingNumber(data) {
    return request({
        url: '/logistics/shipment/create-tracking-number',
        method: 'post',
        data
    })
}

// 生成物流面单
export function createShippingLabel(data) {
    return request({
        url: '/logistics/shipment/create-label',
        method: 'post',
        data
    })
}

export function getPackingPrintDocument(data) {
    return request({
        url: '/package/order/print-document',
        method: 'post',
        data
    })
}

// 获取仓库列表
export function getWarehouseList(params) {
    return request({
        url: '/warehouse/list',
        method: 'get',
        params
    })
}

// 获取物流产品列表
export function getLogisticsProductList(params) {
    return request({
        url: '/logisticsProduct/list',
        method: 'get',
        params
    })
}

export function getPickOrderMainList(params) {
    return request({
        url: '/pickOrderMain/list',
        method: 'get',
        params
    })
}

export function getPickOrders(params) {
    return request({
        url: '/pickOrder/getPickOrders',
        method: 'get',
        params
    })
}

// 查询拣货单详情（包含订单号），用于按SKU打包
export function getPickOrdersWithOrderNo(params) {
    return request({
        url: '/pickOrder/getPickOrdersWithOrderNo',
        method: 'get',
        params
    })
}

// 获取二次分拣数据
export function getSecondaryPickingData(params) {
    return request({
        url: '/pickOrder/getSecondaryPickingData',
        method: 'get',
        params
    })
}

// 按SKU查询一票一件的拣货单
export function getOneTicketOneItemBySku(params) {
    return request({
        url: '/pickOrder/getOneTicketOneItemBySku',
        method: 'get',
        params
    })
}

// 新增：为拣货单分配配货员
export function assignPickers(data) {
    return request({
        url: '/pickOrderMain/assignPicker',
        method: 'post',
        data
    })
}

// 导出拣货明细Excel
export function exportPickOrderDetail(data) {
    return request({
        url: '/pickOrderMain/exportPickOrderDetail',
        method: 'post',
        data,
        responseType: 'blob',
        timeout: 60000,
    }).then(response => {
        if (!response) {
            throw new Error('导出失败：服务器无响应');
        }
        if (!response.headers) {
            throw new Error('导出失败：响应头为空');
        }

        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        let fileName = `拣货明细_${new Date().getTime()}.xlsx`;

        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]) + '.xlsx';
            }
        }

        if (!response.data) {
            throw new Error('导出失败：无导出数据');
        }

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    });
}

// 获取用户列表（用于选择配货员）
export function getUserList(params) {
    return request({
        url: '/wms/user/list',
        method: 'get',
        params
    })
}


export function createPackageMaterial(data) {
    return request({
        url: '/packageMaterial/create',
        method: 'post',
        data
    })
}

export function updatePackageMaterial(data) {
    return request({
        url: '/packageMaterial/update',
        method: 'post',
        data
    })
}

export function getPackageMaterial(params) {
    return request({
        url: '/packageMaterial/list',
        method: 'get',
        params
    })
}

export function createOrdersProduce(data) {
    return request({
        url: '/package/orders',
        method: 'post',
        data
    })
}

export function getPackageMaterialLog(params) {
    return request({
        url: '/packageMaterial/log',
        method: 'get',
        params
    })
}

export function addLogisticsProvider(data) {
    return request({
        url: '/logisticsProvider/add',
        method: 'post',
        data
    })
}

export function getLogisticsProviders(params) {
    return request({
        url: '/logisticsProvider/list',
        method: 'get',
        params
    })
}

export function updateLogisticsProvider(data) {
    return request({
        url: '/logisticsProvider/update',
        method: 'post',
        data
    })
}

export function addLogisticsChannel(data) {
    return request({
        url: '/logisticsChannel/add',
        method: 'post',
        data
    })
}

export function getLogisticsChannels(params) {
    return request({
        url: '/logisticsChannel/list',
        method: 'get',
        params
    })
}

export function getAllLogisticsChannels(params) {
    return request({
        url: '/logisticsChannel/list/all',
        method: 'get',
        params
    })
}

// ================ 物流API服务配置相关接口 ====================
export function addApiService(data) {
  return request({
        url: '/logisticsApiService/add',
        method: 'post',
        data
    })
}

export function getApiServiceList(params) {
    return request({
     url: '/logisticsApiService/list',
        method: 'get',
        params
    })
}

export function updateApiService(data) {
    return request({
        url: '/logisticsApiService/update',
        method: 'post',
        data
    })
}

export function deleteApiService(id) {
    return request({
        url: `/logisticsApiService/delete/${id}`,
        method: 'delete'
    })
}

export function testApiConnection(data) {
    return request({
        url: '/logisticsApiService/test',
        method: 'post',
     data
    })
}

export function getApiServiceByCode(serviceCode) {
    return request({
        url: `/logisticsApiService/getByCode/${serviceCode}`,
      method: 'get'
    })
}

export function updateLogisticsChannel(data) {
    return request({
        url: '/logisticsChannel/update',
        method: 'post',
        data
    })
}

export function addLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/add',
        method: 'post',
        data
    })
}

export function getLogisticsTemplates(params) {
    return request({
        url: '/logisticsTemplate/list',
        method: 'get',
        params
    })
}
export function getActiveLogisticsTemplatesList(){
    return request({
        url: '/logisticsTemplate/listActive',
        method: 'get',
    })
}

export function updateLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/update',
        method: 'post',
        data
    })
}

export function batchAuditLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/batchAudit',
        method: 'post',
        data
    })
}

export function copyLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/copy',
        method: 'post',
        data
    })
}

export function addWeightSegment(data) {
    return request({
        url: '/weightSegment/add',
        method: 'post',
        data
    })
}

export function getWeightSegments(params) {
    return request({
        url: '/weightSegment/list',
        method: 'get',
        params
    })
}

/** 查询模板下已存在的最大截止重量，用于新重量段开始重量自动接续 */
export function getLastWeightEndWeight(logisticsTemplateId) {
    return request({
        url: '/weightSegment/lastEndWeight',
        method: 'get',
        params: {logisticsTemplateId}
    })
}

export function updateWeightSegment(data) {
    return request({
        url: '/weightSegment/update',
        method: 'post',
        data
    })
}

export function deleteWeightSegment(id) {
    return request({
        url: `/weightSegment/delete/${id}`,
        method: 'delete'
    })
}

export function importWeightSegmentByExcel(file, logisticsTemplateId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('logisticsTemplateId', logisticsTemplateId);
    return request({
        url: '/weightSegment/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function downloadWeightSegmentTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/weightSegment/download/template`, '_blank');
}

export function addLogisticsProduct(data) {
    return request({
        url: '/logisticsProduct/add',
        method: 'post',
        data
    })
}

export function getLogisticsProducts(params) {
    return request({
        url: '/logisticsProduct/list',
        method: 'get',
        params
    })
}

export function getActiveLogisticsProducts() {
    return request({
        url: '/logisticsProduct/listActive',
        method: 'get',
    })
}

export function updateLogisticsProduct(data) {
    return request({
        url: '/logisticsProduct/update',
        method: 'post',
        data
    })
}

export function deleteLogisticsProduct(id) {
    return request({
        url: `/logisticsProduct/delete/${id}`,
        method: 'delete'
    })
}

export function addShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/add',
        method: 'post',
        data
    })
}

export function getShippingPartitionSchemes(params) {
    return request({
        url: '/ShippingPartitionScheme/list',
        method: 'get',
        params
    })
}

export function getActiveShippingPartitionSchemes() {
    return request({
        url: '/ShippingPartitionScheme/listActive',
        method: 'get',
    })
}
export function updateShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/update',
        method: 'post',
        data
    })
}

export function batchAuditShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/batchAudit',
        method: 'post',
        data
    })
}

export function copyShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/copy',
        method: 'post',
        data,
        // 大方案的邮编区间是十万级，后端要分批写，默认30秒会被 axios 掐掉（前端报超时但后端还在提交），
        // 这里放宽到10分钟，配合页面上的全屏遮罩提示使用
        timeout: 600000
    })
}

export function addShippingChargePartition(data) {
    return request({
        url: '/ShippingChargePartition/add',
        method: 'post',
        data
    })
}

export function getShippingChargePartitions(id) {
    return request({
        url: `/ShippingChargePartition/get/${id}`,
        method: 'get'
    })
}

export function getShippingChargePartitionsPaged(id, current = 1, size = 50) {
    return request({
        url: `/ShippingChargePartition/page/${id}`,
        method: 'get',
        params: { current, size }
    })
}

export function updateShippingChargePartition(data) {
    return request({
        url: '/ShippingChargePartition/update',
        method: 'post',
        data
    })
}

export function deleteShippingChargePartition(id) {
    return request({
        url: `/ShippingChargePartition/delete/${id}`,
        method: 'delete'
    })
}

export function batchAddShippingChargePartition(data) {
    return request({
        url: '/ShippingChargePartition/batchAdd',
        method: 'post',
        data
    })
}

export function importPartitionByExcel(file, schemeId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('schemeId', schemeId);
    return request({
        url: '/ShippingChargePartition/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function downloadPartitionTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/ShippingChargePartition/download/template`, '_blank');
}

export function addPostalCodeRange(data) {
    return request({
        url: '/PostalCodeRange/add',
        method: 'post',
        data
    })
}

export function getPostalCodeRanges(id) {
    return request({
        url: `/PostalCodeRange/get/${id}`,
        method: 'get'
    })
}

export function getPostalCodeRangesPaged(partitionId, current = 1, size = 50) {
    return request({
        url: `/PostalCodeRange/page/${partitionId}`,
        method: 'get',
        params: { current, size }
    })
}

// 统计指定方案下所有分区的邮编区间总数（用于导入后核对是否导漏）
export function getPostalCodeCountByScheme(schemeId) {
    return request({
        url: `/PostalCodeRange/count/scheme/${schemeId}`,
        method: 'get'
    })
}

export function updatePostalCodeRange(data) {
    return request({
        url: '/PostalCodeRange/update',
        method: 'post',
        data
    })
}

export function deletePostalCodeRange(id) {
    return request({
        url: `/PostalCodeRange/delete/${id}`,
        method: 'delete'
    })
}

export function deletePostalCodeRangesBatch(ids) {
    return request({
        url: '/PostalCodeRange/delete/batch',
        method: 'delete',
        data: ids
    })
}

export function importPostalCodeByExcel(file, schemeId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('schemeId', schemeId);
    return request({
        url: '/PostalCodeRange/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function downloadPostalCodeTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/PostalCodeRange/download/template`, '_blank');
}

export function getPriceCombination(params) {
    return request({
        url: '/logisticsPriceScheme/getPriceCombination',
        method: 'get',
        params
    })
}

export function addLogisticsPriceSchemeWithPrice(data) {
    return request({
        url: '/logisticsPriceScheme/addLogisticsPriceSchemeWithPrice',
        method: 'post',
        data
    })
}

//查询操作费
export function queryOperatingFeesWithGroud(data) {
    return request({
        url: '/lws/fees/grounList',
        method: 'post',
        data,
        headers: {
            repeatSubmit: false  // 查询操作允许重复提交
        }
    })
}

//查询操作费
export function queryOperatingFees(data) {
    return request({
        url: '/lws/fees/list',
        method: 'post',
        data,
        headers: {
            repeatSubmit: false  // 查询操作允许重复提交
        }
    })
}

//保存操作费
export function addOperatingFees(data) {
    return request({
        url: '/lws/fees/add',
        method: 'post',
        data
    })
}

//批量审核操作费
export function batchAuditOperatingFees(data) {
    return request({
        url: '/lws/fees/batchAudit',
        method: 'post',
        data
    })
}

//更新操作费
export function updateOperatingFees(data) {
    return request({
        url: '/lws/fees/update',
        method: 'post',
        data
    })
}

//删除操作费
export function deleteOperatingFees(data) {
    return request({
        url: '/lws/fees/delete',
        method: 'post',
        data
    })
}

//复制操作费（整组复制为新草稿，body 传源操作序号）
export function copyOperatingFees(data) {
    return request({
        url: '/lws/fees/copy',
        method: 'post',
        data
    })
}

//导入操作费Excel
export function importOperatingFeesExcel(formData) {
    return request({
        url: '/lws/fees/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//下载操作费模板
export function downloadOperatingFeesTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/lws/fees/download/template`, '_blank');
}

export function getLogisticsPriceSchemeList(params) {
    return request({
        url: '/logisticsPriceScheme/getLogisticsPriceSchemeList',
        method: 'get',
        params
    })
}

export function getLogisticsPriceByPriceSchemeId(priceSchemeId) {
    return request({
        url: '/logisticsPrice/getByPriceSchemeId',
        method: 'get',
        params: {
            priceSchemeId: priceSchemeId  // 传递价格方案ID参数
        }
    })
}

export function updateLogisticsPriceSchemeWithPrice(data) {
    return request({
        url: '/logisticsPriceScheme/updateLogisticsPriceSchemeWithPrice',
        method: 'post',
        data
    })
}

export function batchUpdateStatus(data) {
    return request({
        url: '/logisticsPriceScheme/batch/updateStatus',
        method: 'post',
        data
    })
}

export function calculateCost(params) {
    return request({
        url: '/logisticsPriceScheme/calculateCost',
        method: 'get',
        params
    })
}

// 新增：下载价格模板接口
export function downloadPriceTemplate(params) {
    return request({
        url: '/logisticsPrice/download-template', // 注意：URL 应与后端 Controller 中定义的一致
        method: 'get',
        params,
        // 关键：告诉 axios 这是一个二进制流响应，不要尝试解析成 JSON
        responseType: 'blob'
    })
}

export function buildDownloadTemplateUrl(params) {
    const baseUrl = '/logisticsPrice/download-template';
    const queryString = new URLSearchParams(params).toString();
    return `${baseUrl}?${queryString}`;
}

export function addFeeType(data) {
    return request({
        url: '/feeType/add',
        method: 'post',
        data
    })
}

export function getFeeTypeList(params) {
    return request({
        url: '/feeType/list',
        method: 'get',
        params
    })
}

/**
 * 查询全部费用类型（不分页，用于下拉选择，避免默认分页 size=10 截断）
 * @returns data 为 FeeType 数组：[{ id, code, nameCn, nameEn, description }]
 */
export function getAllFeeTypes() {
    return request({
        url: '/feeType/list/all',
        method: 'get'
    })
}

export function updateFeeType(data) {
    return request({
        url: '/feeType/update',
        method: 'post',
        data
    })
}

export function addOverLengthWeightRule(data) {
    return request({
        url: '/overLengthWeightRule/add',
        method: 'post',
        data
    })
}

export function listOverLengthWeightRule(params) {
    return request({
        url: '/overLengthWeightRule/list',
        method: 'get',
        params
    })
}

export function updateOverLengthWeightRule(data) {
    return request({
        url: '/overLengthWeightRule/update',
        method: 'post',
        data
    })
}

export function getBillRuleDetail(id) {
    return request({
        url: `/overLengthWeightRule/getBillRuleDetail/${id}`,
        method: 'get'
    })
}

export function batchUpdateOverLengthWeightRule(data) {
    return request({
        url: '/overLengthWeightRule/batchUpdateStatus',
        method: 'post',
        data
    })
}

/**
 * 新增物流特殊费用（含明细）
 * @param {Object} data - 特殊费用信息（LogisticsSpecialFee 对象，含 specialFeeDetails 明细列表）
 * @returns {Promise} - 请求结果
 */
export function addLogisticsSpecialFee(data) {
    return request({
        url: '/logisticsSpecialFee/add',
        method: 'post',
        data
    })
}

/**
 * 分页查询物流特殊费用列表
 * @param {Object} params - 查询参数（LogisticsSpecialFeeQuery 对象）
 * @param {number} params.current - 当前页
 * @param {number} params.size - 每页条数
 * @param {number} [params.status] - 状态（0-未发布，1-已发布）
 * @param {string} [params.logisticsProductId] - 物流产品ID
 * @param {string} [params.location] - 计费地点（模糊查询）
 * @param {string} [params.startTime] - 生效时间（起始，格式：yyyy-MM-dd HH:mm:ss）
 * @param {string} [params.endTime] - 失效时间（结束，格式：yyyy-MM-dd HH:mm:ss）
 * @returns {Promise} - 分页查询结果
 */
export function listLogisticsSpecialFee(params) {
    return request({
        url: '/logisticsSpecialFee/list',
        method: 'get',
        params // get 请求用 params 传递参数（URL 拼接）
    })
}

/**
 * 更新物流特殊费用（含明细）
 * @param {Object} data - 特殊费用更新信息（需携带 id，含 specialFeeDetails 新明细列表）
 * @returns {Promise} - 请求结果
 */
export function updateLogisticsSpecialFee(data) {
    return request({
        url: '/logisticsSpecialFee/update',
        method: 'post',
        data
    })
}

/**
 * 根据特殊费用ID获取明细列表
 * @param {number} specialFeeId - 特殊费用主表ID
 * @returns {Promise} - 明细列表结果
 */
export function getSpecialFeeDetail(specialFeeId) {
    return request({
        url: `/logisticsSpecialFee/getSpecialFeeDetail/${specialFeeId}`, // 路径参数拼接
        method: 'get'
    })
}

/**
 * 批量更新特殊费用状态
 * @param {Object} data - 批量更新参数
 * @param {number[]} data.ids - 特殊费用ID列表
 * @param {number} data.status - 目标状态（0-未发布，1-已发布）
 * @returns {Promise} - 批量更新结果
 */
export function batchUpdateSpecialFeeStatus(data) {
    return request({
        url: '/logisticsSpecialFee/batchUpdateStatus',
        method: 'post',
        data
    })
}


// ==================== 仓库杂费接口（新版，对应 WarehouseMiscFeeController）====================

/**
 * 新增仓库杂费（含明细）
 */
export function addWarehouseMiscFee(data) {
    return request({
        url: '/warehouseMiscFee/add',
        method: 'post',
        data
    })
}

/**
 * 分页查询仓库杂费列表
 */
export function listWarehouseMiscFee(params) {
    return request({
        url: '/warehouseMiscFee/list',
        method: 'get',
        params,
        headers: {
            repeatSubmit: false  // 查询操作允许重复提交
        }
    })
}

/**
 * 更新仓库杂费（含明细）
 */
export function updateWarehouseMiscFee(data) {
    return request({
        url: '/warehouseMiscFee/update',
        method: 'post',
        data
    })
}

/**
 * 根据杂费ID获取明细列表
 */
export function getWarehouseMiscFeeDetail(feeId) {
    return request({
        url: `/warehouseMiscFee/getMiscFeeDetail/${feeId}`,
        method: 'get'
    })
}

/**
 * 批量更新仓库杂费状态
 */
export function batchUpdateWarehouseMiscFeeStatus(data) {
    return request({
        url: '/warehouseMiscFee/batchUpdateStatus',
        method: 'post',
        data
    })
}

/**
 * 单个删除仓库杂费
 */
export function deleteWarehouseMiscFee(id) {
    return request({
        url: `/warehouseMiscFee/delete/${id}`,
        method: 'delete'
    })
}

/**
 * 批量删除仓库杂费
 */
export function batchDeleteWarehouseMiscFee(ids) {
    return request({
        url: '/warehouseMiscFee/batchDelete',
        method: 'post',
        data: ids
    })
}

// ==================== 旧版仓库杂费接口（保留兼容）====================

//保存仓库杂费
export function addMiscellaneous(data) {
    return request({
        url: '/lws/miscellaneous/add',
        method: 'post',
        data
    })
}

//查询仓库杂费
export function getMiscellaneousList(data) {
    return request({
        url: '/lws/miscellaneous/list',
        method: 'post',
        data
    })
}

//删除仓库杂费
export function delMiscellaneousList(data) {
    return request({
        url: '/lws/miscellaneous/del',
        method: 'post',
        data
    })
}

//获取仓库杂费详情（含明细）
export function getMiscellaneousDetail(id) {
    return request({
        url: '/lws/miscellaneous/detail',
        method: 'get',
        params: { id }
    })
}

//修改仓库杂费状态
export function updateMiscellaneousStatus(data) {
    return request({
        url: '/lws/miscellaneous/updateStatus',
        method: 'post',
        data
    })
}
/**
 * 新增物流杂费（含明细）
 */
export function addLogisticsMiscFee(data) {
    return request({
        url: '/logisticsMiscFee/add',
        method: 'post',
        data
    })
}

/**
 * 分页查询物流杂费列表
 */
export function listLogisticsMiscFee(params) {
    return request({
        url: '/logisticsMiscFee/list',
        method: 'get',
        params // get 请求用 params 传递参数（URL 拼接）
    })
}

/**
 * 更新物流杂费（含明细）
 */
export function updateLogisticsMiscFee(data) {
    return request({
        url: '/logisticsMiscFee/update',
        method: 'post',
        data
    })
}

/**
 * 根据杂费规则ID获取明细列表
 */
export function getMiscFeeDetail(miscFeeRuleId) {
    return request({
        url: `/logisticsMiscFee/getMiscFeeDetail/${miscFeeRuleId}`, // 路径参数拼接
        method: 'get'
    })
}

/**
 * 批量更新物流杂费状态
 */
export function batchUpdateMiscFeeStatus(data) {
    return request({
        url: '/logisticsMiscFee/batchUpdateStatus',
        method: 'post',
        data
    })
}
export function batchDeleteLogisticsMiscFee(data){
    return request({
        url: '/logisticsMiscFee/batchDelete',
        method: 'post',
        data
    })
}
export function deleteFeeType(id) {
    return request({
        url: `/feeType/delete/${id}`,
        method: 'delete'
    })
}
export function queryProductsWithInventory(data){
    return request({
        url: '/produce/with-inventory',
        method: 'post',
        data
    })
}

/**
 * 上架：将待上架库存转为可售库存
 */
export function shelvesStock(data) {
    return request({
        url: '/produce/shelves',
        method: 'post',
        data
    })
}

/**
 * 分配出库：将可售库存转为待出库
 */
export function allocateStock(data) {
    return request({
        url: '/produce/allocate',
        method: 'post',
        data
    })
}

/**
 * 确认出库：将待出库转为已出库
 */
export function confirmOutbound(data) {
    return request({
        url: '/produce/confirm-outbound',
        method: 'post',
        data
    })
}

/**
 * 标记不良品
 */
export function markDefective(data) {
    return request({
        url: '/produce/mark-defective',
        method: 'post',
        data
    })
}

export function exportInventoryAll(params) {
    return request({
        url: '/produce/inventory/export/all',
        method: 'get',
        params,
        responseType: 'blob',
        timeout: 60000,
    }).then(response => {
        // 核心修复1：逐层校验 response 和 headers，避免 undefined 取值
        if (!response) {
            throw new Error('导出失败：服务器无响应');
        }
        if (!response.headers) {
            throw new Error('导出失败：响应头为空');
        }

        // 解析文件名（保留原有逻辑，增加兜底）
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        let fileName = `产品库存_${new Date().getTime()}.xlsx`;

        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]) + '.xlsx';
            }
        }

        // 核心修复2：校验 response.data 存在性
        if (!response.data) {
            throw new Error('导出失败：无导出数据');
        }

        // 生成Blob并下载
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    }).catch(error => {
        // 核心修复3：解决二进制错误处理的异步问题（改用 Promise 封装）
        return new Promise((_, reject) => {
            console.error('导出失败:', error);
            // 情况1：无响应/响应头异常（同步错误）
            if (!error.response) {
                reject(new Error(error.message || '导出失败：服务器响应异常'));
                return;
            }

            // 情况2：二进制流错误（异步解析）
            const errorData = error.response.data;
            if (errorData instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    const errorText = reader.result || '导出数据量过大或服务器异常';
                    reject(new Error(errorText));
                };
                reader.onerror = () => {
                    reject(new Error('导出失败：无法解析错误信息'));
                };
                reader.readAsText(errorData);
            } else {
                // 情况3：普通错误
                reject(new Error(error.message || '导出失败，请联系管理员'));
            }
        });
    });
}
// 仓租规则主接口
export function getWarehouseRentRuleList(query) {
    return request({
        url: '/warehouseRentRule/list',
        method: 'get',
        params: query
    })
}

export function getAllWarehouseRentRules() {
    return request({
        url: '/warehouseRentRule/list/all',
        method: 'get'
    })
}

export function getWarehouseRentRuleDetail(ruleId) {
    return request({
        url: `/warehouseRentRule/detail/${ruleId}`,
        method: 'get'
    })
}

export function addWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/add',
        method: 'post',
        data
    })
}

export function updateWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/update',
        method: 'post',
        data
    })
}

export function deleteWarehouseRentRule(ruleId) {
    return request({
        url: `/warehouseRentRule/delete/${ruleId}`,
        method: 'delete'
    })
}

export function batchDeleteWarehouseRentRules(ids) {
    return request({
        url: '/warehouseRentRule/batchDelete',
        method: 'delete',
        data: ids
    })
}

//批量审核仓租规则
export function batchAuditWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/batchAudit',
        method: 'post',
        data
    })
}
//批量无效仓租规则
export function batchInvalidWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/batchInvalid',
        method: 'post',
        data
    })
}

// 仓租阶梯规则接口
export function getWarehouseRentLadders(ruleId) {
    return request({
        url: `/warehouseRentLadder/list/${ruleId}`,
        method: 'get'
    })
}

export function addWarehouseRentLadder(data) {
    return request({
        url: '/warehouseRentLadder/add',
        method: 'post',
        data
    })
}

export function updateWarehouseRentLadder(data) {
    return request({
        url: '/warehouseRentLadder/update',
        method: 'post',
        data
    })
}

export function deleteWarehouseRentLadder(ladderId) {
    return request({
        url: `/warehouseRentLadder/delete/${ladderId}`,
        method: 'delete'
    })
}

export function batchSaveWarehouseRentLadders(ruleId, ladders) {
    return request({
        url: `/warehouseRentLadder/batchSave/${ruleId}`,
        method: 'post',
        data: ladders
    })
}

// ===================== 订单拦截相关API =====================

/**
 * 检查订单是否被拦截（用于打包扫描时检查）
 * @param {String} orderNo - 订单号
 */
export function checkOrderIntercept(orderNo) {
    return request({
        url: '/orderIntercept/checkIntercept',
        method: 'get',
        params: { orderNo }
    })
}

/**
 * 标记拦截失败（已打包出库时调用）
 * @param {String} orderNo - 订单号
 * @param {String} remark - 备注
 */
export function markInterceptFailed(orderNo, remark) {
    return request({
        url: '/orderIntercept/markFailed',
        method: 'post',
        params: { orderNo, remark }
    })
}

/**
 * 分页查询拦截记录（WMS拦截管理用）
 * @param {Object} params - { current, size, status }
 */
export function getInterceptList(params) {
    return request({
        url: '/orderIntercept/list',
        method: 'get',
        params
    })
}

/**
 * 完成拦截操作（WMS确认拦截成功）
 * @param {String} orderNo - 订单号
 * @param {String} completeBy - 完成操作人
 * @param {Boolean} success - 是否成功
 * @param {String} remark - 备注
 */
export function completeOrderIntercept(orderNo, completeBy, success, remark) {
    return request({
        url: '/orderIntercept/complete',
        method: 'post',
        params: { orderNo, completeBy, success, remark }
    })
}

/**
 * 根据订单号查询拦截记录
 * @param {String} orderNo - 订单号
 */
export function getInterceptByOrderNo(orderNo) {
    return request({
        url: '/orderIntercept/getByOrderNo',
        method: 'get',
        params: { orderNo }
    })
}

// ==================== 充值审核管理相关接口 ====================

/**
 * WMS - 查询充值记录列表
 * @param {Object} params - 查询参数
 */
export function getRechargeList(params) {
    return request({
        url: '/wms/recharge/list',
        method: 'get',
        params
    })
}

/**
 * WMS - 根据ID查询充值记录详情
 * @param {Number} id - 充值记录ID
 */
export function getRechargeById(id) {
    return request({
        url: `/wms/recharge/${id}`,
        method: 'get'
    })
}

/**
 * WMS - 审核充值记录
 * @param {Object} data - 审核数据 { id, status, auditRemark }
 */
export function auditRecharge(data) {
    return request({
        url: '/wms/recharge/audit',
        method: 'post',
        data
    })
}

/**
 * WMS - 批量审核充值记录
 * @param {Array} data - 审核数据数组
 */
export function batchAuditRecharge(data) {
    return request({
        url: '/wms/recharge/audit/batch',
        method: 'post',
        data
    })
}

/**
 * WMS - 删除充值记录
 * @param {Array|String} ids - 充值记录ID数组或单个ID
 */
export function deleteRecharge(ids) {
    return request({
        url: `/wms/recharge/${ids}`,
        method: 'delete'
    })
}

// ==================== 退件单相关接口 ====================

/**
 * 根据跟踪号查询退件单（用于到仓扫描）
 * @param {String} trackingNo - 跟踪号
 */
export function getReturnOrderByTrackingNo(trackingNo) {
    return request({
        url: '/returnOrder/getByTrackingNo',
        method: 'get',
        params: { trackingNo }
    })
}

/**
 * 根据扫描码查询退件单（支持订单号、跟踪号、退件单号、参考号）
 * @param {String} scanCode - 扫描码
 */
export function getReturnOrderByScanCode(scanCode) {
    return request({
        url: '/returnOrder/getByScanCode',
        method: 'get',
        params: { scanCode }
    })
}

/**
 * 确认退件单收货
 * @param {Object} data - { returnNo, receiveBy, receiveRemark }
 */
export function confirmReturnOrderReceive(data) {
    return request({
        url: '/returnOrder/confirmReceive',
        method: 'post',
        data
    })
}

/**
 * 确认退件单收货（支持分批多次收货）
 * @param {Object} data - { returnNo, receiveBy, receiveRemark, items: [{ id, currentReceivedQuantity, wmsReturnCode }] }
 */
export function confirmReturnOrderReceiveWithQuantity(data) {
    return request({
        url: '/returnOrder/confirmReceiveWithQuantity',
        method: 'post',
        data
    })
}

/**
 * 完成收货（部分收货→已到仓），不改实收数量
 * @param {Object} params - { returnNo, receiveBy }
 */
export function finishReturnReceive(params) {
    return request({
        url: '/returnOrder/finishReceive',
        method: 'post',
        params
    })
}

/**
 * 退件单上架处理（带库位信息，按库位分区分流可售/不良品/暂存）
 * @param {Object} data - { returnNo, operateBy, items: [{ putawayItemId, productSku, locationCode, locationId, quantity }] }
 */
export function processReturnOrderShelvesWithLocation(data) {
    return request({
        url: '/returnOrder/processShelvesWithLocation',
        method: 'post',
        data
    })
}

// ==================== 财务模块 ====================

/**
 * WMS - 客户账户分页列表（余额/信用额度/可用额度）
 * @param {Object} params - { current, size, userId, userName, customerCode }
 */
export function getFinAccounts(params) {
    return request({
        url: '/wms/finance/accounts',
        method: 'get',
        params
    })
}

/**
 * WMS - 批量查询客户账户（客户列表补充信用额度列用）
 * @param {Array} userIds - 客户用户ID数组
 */
export function getFinAccountsByUsers(userIds) {
    return request({
        url: '/wms/finance/accounts/batch',
        method: 'post',
        data: userIds
    })
}

/**
 * WMS - 单个客户账户总览（含已用信用）
 * @param {Number} userId - 客户用户ID
 */
export function getFinAccountSummary(userId) {
    return request({
        url: '/wms/finance/account',
        method: 'get',
        params: { userId }
    })
}

/**
 * WMS - 资金流水分页查询（全客户）
 * @param {Object} params - { current, size, userId, type, direction, bizNo, customerCode, startDate, endDate }
 */
export function getFinTransactions(params) {
    return request({
        url: '/wms/finance/transactions',
        method: 'get',
        params
    })
}

/**
 * WMS - 调整客户信用额度
 * @param {Object} data - { userId, creditLimit, reason, creditStartTime, creditExpireTime }
 *        creditStartTime / creditExpireTime 传 "yyyy-MM-dd"（后端补齐为当天 00:00:00 / 23:59:59），
 *        传 null 表示该方向不限，两端都不限即长期有效；额度到期后不再计入可用额度
 */
export function adjustCreditLimit(data) {
    return request({
        url: '/wms/finance/credit',
        method: 'post',
        data
    })
}

/**
 * WMS - 信用额度调整历史
 * @param {Object} params - { userId, current, size }
 */
export function getCreditLogs(params) {
    return request({
        url: '/wms/finance/creditLogs',
        method: 'get',
        params
    })
}

/**
 * WMS - 人工调整客户余额（流水类型 manual_adjust）
 * @param {Object} data - { userId, amount, direction(+调增/-调减), reason }
 */
export function adjustBalance(data) {
    return request({
        url: '/wms/finance/adjustBalance',
        method: 'post',
        data
    })
}

/**
 * WMS - 批量导入余额（multipart/form-data，逐行写 manual_adjust 流水）
 * @param {FormData} formData - file(Excel) + mode(increment增量/override覆盖) + reason(导入原因)
 */
export function importBalance(formData) {
    return request({
        url: '/wms/finance/importBalance',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000
    })
}

/**
 * WMS - 单票报价：分页查询订单费用明细列表（仅计费完成订单）
 * @param {Object} params - { current, size, orderNo, customerCode, customerName, warehouse, startDate, endDate }
 */
export function getOrderFees(params) {
    return request({
        url: '/wms/finance/orderFees',
        method: 'get',
        params
    })
}

/**
 * WMS - 单票报价：修改某订单的费用明细（分项录入，总费用自动汇总；已扣费订单按差额联动余额）
 * @param {Object} data - { orderNo, mainCost, operateFee, overLengthWeightFee, miscFee, currency, reason, feeItems }
 */
export function updateOrderFee(data) {
    return request({
        url: '/wms/finance/orderFee/update',
        method: 'post',
        data
    })
}

/**
 * WMS - 重新计费：按订单商品重走费用试算并应用当前客户费用折扣
 * 仅「计费完成」订单；已扣费订单按总费用差额联动余额（order_fee_adjust 审计流水）
 * @param {Object} data - { orderNo }
 */
export function recalculateOrderFee(data) {
    return request({
        url: '/wms/finance/orderFee/recalculate',
        method: 'post',
        data
    })
}

/**
 * WMS - 手工应收：应收单分页列表
 * @param {Object} params - { current, size, receivableNo, customerCode, customerName, status, startDate, endDate }
 */
export function getReceivables(params) {
    return request({
        url: '/wms/finance/receivables',
        method: 'get',
        params
    })
}

/**
 * WMS - 手工应收：登记应收单（待收款；币种服务端取客户账户币种）
 * @param {Object} data - { userId, feeTypeId, amount, reason }
 */
export function createReceivable(data) {
    return request({
        url: '/wms/finance/receivable/create',
        method: 'post',
        data
    })
}

/**
 * WMS - 手工应收：编辑应收单（仅待收款可改：费用类型/金额/事由）
 * @param {Object} data - { id, feeTypeId, amount, reason }
 */
export function updateReceivable(data) {
    return request({
        url: '/wms/finance/receivable/update',
        method: 'post',
        data
    })
}

/**
 * WMS - 手工应收：收款（从客户余额全额扣款核销，可用额度不足返回505）
 * @param {Object} data - { id, remark(可选) }
 */
export function collectReceivable(data) {
    return request({
        url: '/wms/finance/receivable/collect',
        method: 'post',
        data
    })
}

/**
 * WMS - 手工应收：作废应收单（仅待收款可作废，原因必填）
 * @param {Object} data - { id, reason }
 */
export function cancelReceivable(data) {
    return request({
        url: '/wms/finance/receivable/cancel',
        method: 'post',
        data
    })
}

/**
 * WMS - 手工应收：批量导入应收单（multipart/form-data；导入为待收款；费用类型未匹配归「其他费用」）
 * @param {FormData} formData - file(Excel)，表头：客户代码/费用类型/金额/事由
 */
export function importReceivables(formData) {
    return request({
        url: '/wms/finance/receivable/import',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000
    })
}

/**
 * WMS - 手工应收：批量收款（勾选多张待收款单逐张扣款核销，失败行不影响成功行）
 * @param {Object} data - { ids: [应收单ID, ...] }
 */
export function batchCollectReceivables(data) {
    return request({
        url: '/wms/finance/receivable/batchCollect',
        method: 'post',
        data
    })
}

/**
 * WMS - 客户费用折扣：折扣配置分页列表
 * @param {Object} params - { current, size, customerCode, customerName }
 */
export function getCustomerDiscounts(params) {
    return request({
        url: '/wms/finance/discounts',
        method: 'get',
        params
    })
}

/**
 * WMS - 客户费用折扣：保存折扣配置（一户一条 upsert，分项折扣率 % 0-100，100=不打折）
 * @param {Object} data - { userId, mainCostRate, operateFeeRate, overLengthWeightFeeRate, miscFeeRate, remark }
 */
export function saveCustomerDiscount(data) {
    return request({
        url: '/wms/finance/discount/save',
        method: 'post',
        data
    })
}

/**
 * WMS - 客户费用折扣：删除折扣配置（删除后新计费不再打折，历史订单留痕不变）
 * @param {Object} data - { id }
 */
export function deleteCustomerDiscount(data) {
    return request({
        url: '/wms/finance/discount/delete',
        method: 'post',
        data
    })
}

/**
 * WMS - 仓租账单：分页列表
 * @param {Object} params - { current, size, customerCode, customerName, warehouseId, startDate, endDate, billType, deductStatus }
 */
export function getRentBills(params) {
    return request({
        url: '/wms/finance/rent/bills',
        method: 'get',
        params
    })
}

/**
 * WMS - 仓租账单：详情（日账单带批次明细 details；月账单带关联日计提列表 dailyBills）
 * @param {number|string} id - 账单ID
 */
export function getRentBillDetail(id) {
    return request({
        url: `/wms/finance/rent/bill/detail/${id}`,
        method: 'get'
    })
}

/**
 * WMS - 仓租试算（不落库不扣款）
 * @param {Object} data - { date | startDate+endDate, warehouseId }，日期 yyyy-MM-dd
 */
export function previewRent(data) {
    return request({
        url: '/wms/finance/rent/preview',
        method: 'post',
        data
    })
}

/**
 * WMS - 生成仓租账单（已存在日期自动跳过）
 * @param {Object} data - { startDate, endDate, warehouseId, deduct }
 *                        deduct=true 日结账单生成后立即扣款；false 仅生成「待扣费」账单，核对后批量扣款
 *                        结束日不得晚于昨天，跨度≤31天
 */
export function generateRentBills(data) {
    return request({
        url: '/wms/finance/rent/generate',
        method: 'post',
        data
    })
}

/**
 * WMS - 仓租月结汇总：把指定月份「已计提待汇总」的日行汇总为月账单并扣款
 * @param {Object} data - { month: 'yyyy-MM', warehouseId }，month 必须早于当月
 */
export function settleMonthlyRent(data) {
    return request({
        url: '/wms/finance/rent/settleMonthly',
        method: 'post',
        data
    })
}

/**
 * WMS - 仓租扣费重试：对「待扣费/扣费失败」账单重新扣款（流水幂等，不会重复扣）
 * @param {Object} data - { ids: [账单ID] }
 */
export function retryRentDeduct(data) {
    return request({
        url: '/wms/finance/rent/retryDeduct',
        method: 'post',
        data
    })
}

/**
 * WMS - 库存流水：分页列表（当前库存 = 期初 + Σ流水 可核对）
 * @param {Object} params - { current, size, productSku, warehouseId, bizType, bizNo, startDate, endDate, operator }
 */
export function getInventoryLogs(params) {
    return request({
        url: '/wms/inventory/logs/list',
        method: 'get',
        params
    })
}

/**
 * WMS - 库存流水导出 Excel（按查询条件，不分页，上限 2 万条）
 * @param {Object} data - 同分页查询条件
 */
export function exportInventoryLogs(data) {
    return downloadRentExcel('/wms/inventory/logs/export', data, '库存流水');
}

/**
 * WMS - 库位库存：分页列表（一行 = 产品 x 库位 x 上架批次）
 * @param {Object} params - { current, size, productSku, warehouseId, locationCode }
 */
export function getLocationStocks(params) {
    return request({
        url: '/wms/location-stock/list',
        method: 'get',
        params
    })
}

/**
 * WMS - 库位库存对账：按(产品,仓库)对比库位库存合计与库存表在架量
 */
export function checkLocationStock() {
    return request({
        url: '/wms/location-stock/check',
        method: 'get'
    })
}

/**
 * WMS - 库位库存存量迁移是否已执行（一次性操作，已迁移则页面隐藏迁移按钮）
 */
export function isLocationStockMigrated() {
    return request({
        url: '/wms/location-stock/migrated',
        method: 'get'
    })
}

/**
 * WMS - 库位库存存量迁移（幂等，只可执行一次）：历史漂移以「迁移差额」行补齐
 */
export function migrateLocationStock() {
    return request({
        url: '/wms/location-stock/migrate',
        method: 'post'
    })
}

/**
 * WMS - 手动调整库位批次数量（盘点纠错）：库位行+可售/总库存同事务加减 delta
 * @param {Object} data - { id, newQuantity, remark }
 */
export function adjustLocationStock(data) {
    return request({
        url: '/wms/location-stock/adjust',
        method: 'post',
        data
    })
}

/**
 * WMS - 调整批次库位（同仓库内移位，可拆分部分数量移动）
 * moveQuantity 等于当前数量 = 整行移位；小于当前数量 = 拆分（源行留余量，新库位建新批次行，
 * 沿用上架时间/来源单号），总量与库存汇总层不变
 * @param {Object} data - { id, newLocationId, moveQuantity, remark }
 */
export function moveLocationStock(data) {
    return request({
        url: '/wms/location-stock/move',
        method: 'post',
        data
    })
}

/**
 * WMS - 库位流水：分页列表（location_stock_log，一行 = 一次库位批次变动）
 * @param {Object} params - { current, size, productSku, warehouseId, locationCode, bizType, bizNo, startDate, endDate }
 */
export function getLocationStockLogs(params) {
    return request({
        url: '/wms/location-stock/logs',
        method: 'get',
        params
    })
}

/**
 * WMS - 库位流水导出 Excel（按查询条件，不分页，上限 2 万条）
 * @param {Object} data - 同分页查询条件
 */
export function exportLocationStockLogs(data) {
    return downloadRentExcel('/wms/location-stock/exportLogs', data, '库位流水');
}

/**
 * WMS - 仓租账单作废：未扣款直接作废；已扣费自动退回余额（manual_adjust 流水）；
 * 月账单作废后关联日计提恢复「已计提待汇总」；作废后同客户+仓库+日期可重新生成
 * @param {Object} data - { id }
 */
export function voidRentBill(data) {
    return request({
        url: '/wms/finance/rent/void',
        method: 'post',
        data
    })
}

/**
 * WMS - 导出仓租账单 Excel（按查询条件，不分页）
 * @param {Object} data - 同分页查询条件 { customerCode, customerName, warehouseId, startDate, endDate, billType, deductStatus }
 */
export function exportRentBills(data) {
    return downloadRentExcel('/wms/finance/rent/exportBills', data, '仓租账单');
}

/**
 * WMS - 导出仓租批次明细 Excel（一行一个上架批次：SKU/库位/上架时间/库龄/计费量/单价/金额）
 * @param {Object} data - 同分页查询条件（月汇总行无直接明细，自动只取日账单/日计提行）
 */
export function exportRentDetails(data) {
    return downloadRentExcel('/wms/finance/rent/exportDetails', data, '仓租批次明细');
}

// 仓租导出公共下载逻辑（blob -> 触发浏览器下载，文件名优先取响应头）
function downloadRentExcel(url, data, defaultName) {    return request({
        url,
        method: 'post',
        data,
        responseType: 'blob',
        timeout: 300000,
    }).then(response => {
        if (!response || !response.data) {
            throw new Error('导出失败：服务器无响应');
        }
        let fileName = `${defaultName}_${new Date().getTime()}.xlsx`;
        const contentDisposition = response.headers &&
            (response.headers['content-disposition'] || response.headers['Content-Disposition']);
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/i);
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
        }
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
    });
}

// Get shipped order for WMS warehouse-arrival scan (auto create service-provider return order)
export function getShippedOrder(code) {
    return request({
        url: '/returnOrder/getShippedOrder',
        method: 'get',
        params: { code }
    })
}

// Create return order from WMS scan (shipped order confirm receive)
export function createReturnByWmsScan(data) {
    return request({
        url: '/returnOrder/createByWmsScan',
        method: 'post',
        data
    })
}

// Reject return order receive (mark as abnormal)
export function rejectReturnOrderReceive(returnNo) {
    return request({
        url: '/returnOrder/rejectReceive',
        method: 'post',
        params: { returnNo }
    })
}

// Create claim order (WMS warehouse-arrival scan - create claim item)
export function createClaimOrder(data) {
    return request({
        url: '/claimOrder/create',
        method: 'post',
        data
    })
}

// Update claim order (WMS)
export function updateClaimOrder(data) {
    return request({
        url: '/claimOrder/update',
        method: 'post',
        data
    })
}

// Calculate claim operation fee (WMS)
export function calculateClaimOperationFee(data) {
    return request({
        url: '/claimOrder/calculateOperationFee',
        method: 'post',
        data
    })
}

// Void claim order (WMS)
export function voidClaimOrder(data) {
    return request({
        url: '/claimOrder/wms/void',
        method: 'post',
        data
    })
}

// Batch void claim orders (WMS)
export function batchVoidClaimOrder(data) {
    return request({
        url: '/claimOrder/wms/batchVoid',
        method: 'post',
        data
    })
}

// Query claim order list with pagination (WMS)
export function getClaimOrderList(params) {
    return request({
        url: '/claimOrder/list',
        method: 'get',
        params
    })
}

// Query claim order detail by claimNo
export function getClaimOrderDetail(claimNo) {
    return request({
        url: '/claimOrder/detail/' + claimNo,
        method: 'get'
    })
}

// Query claim order operation logs (WMS)
export function getClaimOrderLogs(claimNo) {
    return request({
        url: '/claimOrder/logs',
        method: 'get',
        params: { claimNo }
    })
}

// Generate claim order PDF (WMS)
export function generateClaimPdf(claimNo, printStyle = 'claimList', printSize = 'A4') {
    return request({
        url: '/claimOrder/print/generatePdf',
        method: 'get',
        params: { claimNo, printStyle, printSize },
        timeout: 60000
    })
}

// Upload claim order photos (WMS)
export function uploadClaimPhoto(data) {
    return request({
        url: '/claimOrder/wms/photo',
        method: 'post',
        data
    })
}

// Confirm claim order destroy (WMS)
export function confirmClaimDestroy(data) {
    return request({
        url: '/claimOrder/wms/confirmDestroy',
        method: 'post',
        data
    })
}

// 国家字典分页列表
export function listCountry(params) {
    return request({
        url: '/wms/country/list',
        method: 'get',
        params
    })
}

// 所有启用国家（管理页备用）
export function getCountryAll() {
    return request({
        url: '/wms/country/all',
        method: 'get'
    })
}

// 新增国家
export function addCountry(data) {
    return request({
        url: '/wms/country/add',
        method: 'post',
        data
    })
}

// 修改国家（编码被收费分区/超长超重规则引用时后端拒绝，msg 由 request 拦截器统一弹出）
export function updateCountry(data) {
    return request({
        url: '/wms/country/update',
        method: 'post',
        data
    })
}

// 删除国家（被引用时后端拒绝，msg 由 request 拦截器统一弹出）
export function deleteCountry(id) {
    return request({
        url: `/wms/country/delete/${id}`,
        method: 'delete'
    })
}
